import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';
import { GlobalSetupService } from 'src/app/services/global-setup.service';
import { AuthService } from 'src/app/services/auth.service';
import { UserSettingsService } from 'src/app/services/user-settings.service';
import { ProgressSpinner } from 'primeng/progressspinner';
import { GlobalSetupModalComponent } from '../global-setup-modal/global-setup-modal.component';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-global-setup-monitor',
  imports: [CommonModule, ProgressSpinner, GlobalSetupModalComponent],
  standalone: true,
  templateUrl: './global-setup-monitor.component.html',
  styleUrl: './global-setup-monitor.component.scss'
})
export class GlobalSetupMonitorComponent {
  isInitializing = false;
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private globalSetupService: GlobalSetupService,
     private authService: AuthService,
    private userSettingsService: UserSettingsService
  ) { }

  ngOnInit(): void {
    // Check setup on initial load
    this.checkSetupAndInitialize();

    // Check setup on route changes only if necessary
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        // Only check setup on route changes if we don't already know the state
        // or if setup is currently required (in case user completed setup in another tab)
        if (this.globalSetupService.setupRequired) {
          this.checkSetupQuietly();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private async checkSetupAndInitialize(): Promise<void> {
    const currentPath = window.location.pathname;
    
    // Only check setup on LinkedIn and outreach pages
    if (!this.shouldCheckSetupForCurrentPage(currentPath)) {
      return;
    }
    
    console.log('Checking settings for:', currentPath);
    
    try {
      this.isInitializing = true;
      await this.globalSetupService.checkGlobalSetup(
        this.authService,
        this.userSettingsService
      );
      console.log('Settings check complete');
    } catch (error) {
      console.error('Error during initial setup check:', error);
    } finally {
      this.isInitializing = false;
    }
  }

  private async checkSetupQuietly(): Promise<void> {
    const currentPath = window.location.pathname;
    
    // Only check setup on LinkedIn and outreach pages
    if (!this.shouldCheckSetupForCurrentPage(currentPath)) {
      return;
    }
    
    try {
      await this.globalSetupService.checkGlobalSetup(
        this.authService,
        this.userSettingsService,
        true // Pass true for quiet check
      );
    } catch (error) {
      console.error('Error during route setup check:', error);
    } finally {
      this.isInitializing = false;
    }
  }

  private shouldCheckSetupForCurrentPage(currentPath: string): boolean {
    // Skip login and settings pages
    if (currentPath === '/login' || currentPath === '/settings') {
      return false;
    }
    
    // Only check on LinkedIn and outreach pages
    return currentPath.includes('/linkedin') || currentPath.includes('/email-outreach');
  }

 
}
